@let localIsVideo = isVideo(); @let localItemVr = itemVr();

<div
  class="card position-relative w-100 rounded-3 overflow-hidden shadow-sm d-flex justify-content-center align-items-center cursor-pointer h-100"
  (click)="redirecTo()"
>
  <div
    class="badge position-absolute top-0 start-0 z-1 bg-dark-blue d-flex align-items-center gap-2 pe-3"
  >
    <img
      height="16"
      [lazyLoad]="localIsVideo ? '/img/icons/video_icon.svg' : '/img/icons/360_icon.svg'"
      alt=""
    />
    <span class="text-white">{{ localIsVideo ? 'Video VR' : 'Recorrido VR' }}</span>
  </div>

  <div class="card-image h-100 w-100">
    <img
      class="w-100 h-100 object-fit-cover"
      [lazyLoad]="(localIsVideo ? localItemVr.image : localItemVr.image) | cdnUrl: 600 : true"
      alt=""
    />
  </div>

  <div class="position-absolute content-vr rounded-circle p-2">
    <i class="inm-icon-vr-glasses text-white" style='font-size: 25px'></i>
  </div>
</div>
